<ng-container *ngIf="isMobile ; else isDesktop">
  <ng-container *ngIf="back; else isHome">
    <app-sidenav [back]="back" [destination]="destination" [title]="title"></app-sidenav>
  </ng-container>
  <ng-template #isHome>
    <app-sidenav></app-sidenav>
  </ng-template>
</ng-container>

<ng-template #isDesktop>
<mat-toolbar color="primary" class="mat-elevation-z5" fxLayout="row" fxLayoutAlign="start center">
  <mat-toolbar-row>
    <ng-container *ngIf="back; else homeNav">
      <span class="material-icons && back-nav" routerLink="/{{destination}}">navigate_before</span>
    </ng-container>
    <ng-template #homeNav>
      <span class="material-icons && back-nav">home</span>
    </ng-template>
    <div style="margin-left: 40px">

      <ng-container *ngIf="title; else home">
        <span>{{title}}</span>
      </ng-container>
      <ng-template #home>
        Benvenuto
      </ng-template>
    </div>

    <div id="iconHome">
    <ng-container *ngIf="back">
        <span routerLink="/landing"><mat-icon>home</mat-icon></span>
    </ng-container>
    </div>

    <span class="spacer"></span>
    <ng-container *ngIf="user">
      <ng-container *ngIf="!messagesUnread">
      <span *ngIf="user.role.includes('PAZIENTE')" id="chatIconPatient" class="material-icons" routerLink="/patient-chat">chat</span>
      <span *ngIf="user.role.includes('DOTTORE')" id="chatIconDoctor" class="material-icons" routerLink="/doctor-chat">chat</span>
      </ng-container>
      <ng-container *ngIf="messagesUnread">
        <span *ngIf="user.role.includes('PAZIENTE')" matBadge="!" matBadgeColor="warn" id="chatIconPatientUnread" class="material-icons" routerLink="/patient-chat">chat</span>
        <span *ngIf="user.role.includes('DOTTORE')" matBadge="!" matBadgeColor="warn"  id="chatIconDoctorUnread" class="material-icons" routerLink="/doctor-chat">chat</span>
      </ng-container>

      <ng-container *ngIf="notifications; else noNotifications">
        <span class="material-icons" matBadge="{{notifications}}" routerLink="/notifications" matBadgeColor="warn" style="cursor: pointer; margin-right: 15px">notifications</span>
      </ng-container>
      <ng-template #noNotifications>
        <span class="material-icons" routerLink="/notifications" style="cursor: pointer; margin-right: 15px">notifications</span>
      </ng-template>
        <button mat-button [matMenuTriggerFor]="menu">{{user.name}} {{user.surname}}</button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item routerLink="/settings">Impostazioni</button>
        <button mat-menu-item routerLink="/password-setting">Cambio password</button>
        <button mat-menu-item (click)="logout()">Esci</button>
      </mat-menu>
    </ng-container>
  </mat-toolbar-row>
</mat-toolbar>
</ng-template>
